import React from 'react'

import { Popover } from 'antd'

import { useSelectOptionsContext } from '../../context/selectOptions'
import { useGetSelectOptionsQuery } from '../../services/selectOption'

import './styles.less'

export function ViewOptionRelationshipsPopover({ children, option, visible }) {
  const { fieldRelationships, fields, relatedFieldIds, optionRelationships } = useSelectOptionsContext()

  if (!visible) return children

  return (
    <Popover
      visible
      transitionName="none"
      overlayClassName="viewOptionRelationships"
      content={relatedFieldIds.map((fieldId) => {
        const field = fields.entities[fieldId]
        const fieldRelationshipId = fieldRelationships[fieldId]

        const key = `${fieldRelationshipId}_${option?.id}`
        const relatedOptionId = optionRelationships?.entities[key]?.relatedOptionId

        const selectedOption = useGetSelectOptionsQuery({ fieldId })?.data?.entities[relatedOptionId]

        return (
          <div key={key} className="viewOptionRelationships__wrapper">
            <div className="viewOptionRelationships__relationship">
              <span>{field.fieldName}</span>
              <span>{selectedOption?.description || '---'}</span>
            </div>
            <hr />
          </div>
        )
      })}
      placement="topLeft"
      arrowPointAtCenter={true}
    >
      {children}
    </Popover>
  )
}
